import { Tooltip } from '@/components/tooltip';
import { TrafficLight } from '@/components/traffic-light';
import { VehicleDelayTooltip } from '@/components/vehicle-delay-tooltip';
import { VisuallyHidden } from '@/components/visually-hidden';
import { DELAY_STATUS } from '@/lib/constants';
import { VehicleDelayInterface } from '@/types';
import { formatDelayStatusLabel } from '@/utils/strings';

interface Props {
  delay: VehicleDelayInterface | undefined;
}

const VehicleDelayStatus = ({ delay }: Props) => {
  const hasStatus = !!delay?.status;
  const isDelayed = delay?.status === DELAY_STATUS.DELAYED;

  return (
    <Tooltip content={<VehicleDelayTooltip delay={delay} />} followCursor="horizontal">
      {hasStatus && isDelayed && <TrafficLight color="red" showAlertIcon />}
      <VisuallyHidden>{formatDelayStatusLabel(delay)}</VisuallyHidden>
    </Tooltip>
  );
};

export { VehicleDelayStatus };
